<template>
	<div
		id="app"
		:class="{'app--dark':darkMode}">
		<template v-if="!loggedIn">
			<router-view/>
		</template>
		<template v-else>
			<Navigation v-if="$mq === 'lg'"></Navigation>
			<NavigationMobile v-else></NavigationMobile>
			<Page></Page>
			<Social v-if="$mq === 'lg'"></Social>
		</template>
		<Modal></Modal>
	</div>
</template>

<script>
import Navigation from './components/Navigation'
import NavigationMobile from './components/mobile/NavigationMobile'
import Page from './components/Page'
import Social from './components/Social'
import Modal from './components/Modal'

export default {
	components: {
		Navigation,
		NavigationMobile,
		Page,
		Social,
		Modal
	},
	watch: {
		'$route': function () {
			// Check if the user is logged in. If not, reroute to the homepage.
			if (!this.loggedIn && !this.pageIsPublic) this.$router.push('/')
		}
	},
	computed: {
		darkMode () {
			return this.$store.state.settings.darkMode
		},
		loggedIn () {
			return this.$store.state.authentication.loggedIn
		},
		pageIsPublic () {
			const publicPages = ['login', 'register', 'verify']
			return publicPages.includes(this.$route.name)
		}
	},
	created () {
		const route = this.$route
		// Rerouting if necessary
		if (!this.loggedIn) {
			if (!this.loggedIn && !this.pageIsPublic) this.$router.push('/')
		}	else if (route.path === '/') this.$router.push('/plannings')
		// Obtain plannings
		if (this.loggedIn) {
			// Check if the route handles planning refresh itself
			if (route.name !== 'planning') this.$store.dispatch('getPlannings')
			this.$store.dispatch('getFriends')
		}
	}
}
</script>

<style lang="scss" src="./styles/main.scss">
</style>
